module.exports = __webpack_public_path__ + "img/clinics_ladies.21c47d1a.jpg";